import React, { useState } from 'react';
import { Box, Button, IconButton, Stack, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CloseIcon from '@mui/icons-material/Close';
import tempProductImg from "../../images/temp_atpl_product_img.png";
import AtplPrimaryBt from '../../components/ATPlab/AtplPrimaryBtn/AtplPrimaryBt';
const AtplCart = () => {
    const [count, setCount] = useState(1);
    const handleIncrement = () => {
        setCount(count + 1);
    };

    const handleDecrement = () => {
        if (count > 0) {
            setCount(count - 1);
        }
    };

    const dummyProductDataForCheckoutPage = [
        {
            productName: "Omega-3 Triglyceride - Green Apple/200 ml",
            productPrice: "$48.99 CAD",
            productImg: tempProductImg,
            productCurrentQuantity: 1,
        },
        {
            productName: "Hepatik Defence",
            productPrice: "$30.49 CAD",
            productImg: tempProductImg,
            productCurrentQuantity: 1,
        },
        {
            productName: "Synermag",
            productPrice: "$27.99 CAD",
            productImg: tempProductImg,
            productCurrentQuantity: 1,
        },


    ]
    return (
        <Box className="atpl-intro-wrapper" height="100vh">
            <Box >
                <Box sx={{ height: "65vh", overflowY: "auto" }} >
                    {
                        dummyProductDataForCheckoutPage.length && dummyProductDataForCheckoutPage.map((cartProduct, index) => (
                            <Stack key={index} margin="14px 0px" padding="10px 0px" minHeight="100px">
                                <Stack display="flex" flexDirection="row" justifyContent="space-between"  >
                                    <Box>
                                        <img style={{ width: "70px", height: "auto" }} src={tempProductImg}></img>
                                    </Box>
                                    <Box sx={{
                                        padding: "0px 20px",
                                        width: "100%",
                                    }}>
                                        <Stack>
                                            <Typography fontSize="12px" fontWeight="400" color="grey">ATP LAB</Typography>
                                            <Typography fontSize="14px" fontWeight="600" color="black">{cartProduct.productName}</Typography>
                                        </Stack>
                                        <Stack sx={{
                                            display: "flex",
                                            height: "50px",
                                            justifyContent: "flex-end"

                                        }}>

                                            <Box sx={{
                                                height: "20px",
                                                width: "70px",
                                                display: "flex",
                                                justifyContent: "space-evenly",
                                                alignItems: "center",
                                            }}>

                                                <IconButton onClick={handleDecrement} aria-label="decrease" sx={{ padding: "0px" }} >
                                                    <RemoveIcon sx={{ fontSize: 16 }} />
                                                </IconButton>
                                                <Typography variant="h6" fontSize="16px" >
                                                    {cartProduct.productCurrentQuantity}
                                                </Typography>
                                                <IconButton onClick={handleIncrement} aria-label="increase" style={{ width: "10px" }}>
                                                    <AddIcon sx={{ fontSize: 16 }} />
                                                </IconButton>
                                            </Box>
                                        </Stack>

                                    </Box>


                                    <Box>
                                        <IconButton aria-label="decrease" sx={{ padding: "0px" }}>
                                            <CloseIcon sx={{ fontSize: 18, color: "black" }} />
                                        </IconButton>

                                    </Box>
                                </Stack>

                                <Stack >
                                    <Typography textAlign="right" fontSize="14px" color="#727272" fontWeight="500">{cartProduct.productPrice}</Typography>
                                </Stack>
                            </Stack>
                        ))
                    }
                </Box>
                <Box>
                    <Stack margin="10px 0px">
                    <Stack display="flex" flexDirection="row" justifyContent="space-between" margin="10px 0px">
                        <Typography>Total</Typography>
                        <Typography>$27.99 CAD</Typography>
                    </Stack>
                    <Stack width="100%" >

                        <Button sx={{ backgroundColor: "#E94E1B", color: "white", height: "40px" }}>CHECKOUT</Button>

                    </Stack>
                    </Stack>
                    <Stack display="flex" flexDirection="row" justifyContent="space-between" padding="10px" width="95%" height="16vh" alignItems="center" backgroundColor="#d7dfe3">
                        <Stack display="flex" flexDirection="row">
                            <img style={{ width: "auto", height: "80px", padding: "0px 10px 10px 0px" }} src={tempProductImg}></img>

                            <Typography variant="h6" sx={{ paddingleft: "15px", fontSize: "14px" }}>Total Defence</Typography>
                        </Stack>
                        <Stack sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                            <Button style={{ fontSize: "12px", color: "black", padding: "0px", marginBottom: "20px" }}>ADD+</Button>
                            <Typography style={{ fontSize: "14px", fontWeight: "600", color: "black", padding: "0px", }}> $67.99 CAD</Typography>
                        </Stack>

                    </Stack>

                </Box>


            </Box>
        </Box>
    )
}




export default AtplCart

